
    import {Component, Vue} from 'vue-property-decorator';

    @Component
    export default class EnRedirect extends Vue {
        private created() {
            // 拿到pathname
            const hostname = window.location.hostname;
            const arr: string[] = hostname.split('.');
            // 获得一级域名
            const fld: string = arr[arr.length - 2] + '.' + arr[arr.length - 1];
            // 构建企业后台地址并跳转
            window.location.href = 'https://' + this.$route.params.sld + '.' + fld + '/kk-user/bs';
        }
    }
